import React from 'react'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { Col } from 'reactstrap'
import { BoxHeader } from '@/components/Layout'
import { formatDate } from '@/utils/dateUtilities'
import { getName } from '@/utils/nameHelpers'

export const IndividualsComparisonDetail = React.memo(function IndividualsComparisonDetail (props) {
  const { individual, duplicateIndividual, normalizedIndividual, normalizedDuplicateIndividual, duplicateAttributes, weight } = props

  const firstNameAttribute = duplicateAttributes && duplicateAttributes.find(x => x.attributeName === 'FirstName')
  const surNameAttribute = duplicateAttributes && duplicateAttributes.find(x => x.attributeName === 'Surname')
  const fatherNameAttribute = duplicateAttributes && duplicateAttributes.find(x => x.attributeName === 'FatherName')
  const grandfatherNameAttribute = duplicateAttributes && duplicateAttributes.find(x => x.attributeName === 'GrandfatherName')
  const greatGrandfatherNameAttribute = duplicateAttributes && duplicateAttributes.find(x => x.attributeName === 'GreatGrandfatherName')
  const birthDateAttribute = duplicateAttributes && duplicateAttributes.find(x => x.attributeName === 'BirthDate')
  const personalIdsAttribute = duplicateAttributes && duplicateAttributes.find(x => x.attributeName === 'PersonalIds')

  function getPercentValue (value) {
    return ((value / weight) * 100)
  }

  return <React.Fragment>
    <Col>
      <BoxHeader className='header'>{getName(normalizedIndividual)}</BoxHeader>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.Name' /></InfoLabel>
        <InfoContent>{normalizedIndividual.firstName}  {firstNameAttribute && `(${getPercentValue(firstNameAttribute.weight)}%)`}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.Surname' /></InfoLabel>
        <InfoContent>{normalizedIndividual.surname} {surNameAttribute && `(${getPercentValue(surNameAttribute.weight)}%)`}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.FatherName' /></InfoLabel>
        <InfoContent>{normalizedIndividual.fatherName} {fatherNameAttribute && `(${getPercentValue(fatherNameAttribute.weight)}%)`}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.GrandfatherName' /></InfoLabel>
        <InfoContent>{normalizedIndividual.grandfatherName} {grandfatherNameAttribute && `(${getPercentValue(grandfatherNameAttribute.weight)}%)`}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.GreatGrandfatherName' /></InfoLabel>
        <InfoContent>{normalizedIndividual.greatGrandfatherName} {greatGrandfatherNameAttribute && `(${getPercentValue(greatGrandfatherNameAttribute.weight)}%)`}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.BirthDate' /></InfoLabel>
        <InfoContent>{formatDate(individual.birthDate)} {birthDateAttribute && `(${getPercentValue(birthDateAttribute.weight)}%)`}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.PersonalIds' /></InfoLabel>
        <InfoContent>
          <table style={{ width: '100%' }}>
            <tbody>
              {individual.personalIds.map(personalId =>
                <tr key={`individualComparison_personalId_${personalId.id}`}>
                  <td>
                    {personalId.type.name}
                  </td>
                  <td>
                    {personalId.number}
                  </td>
                </tr>)}
            </tbody>
          </table>
          {personalIdsAttribute && `(${getPercentValue(personalIdsAttribute.weight)}%)`}
        </InfoContent>
      </InfoRow>
    </Col>
    <Col>
      <BoxHeader className='header'>{getName(normalizedDuplicateIndividual)}</BoxHeader>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.Name' /></InfoLabel>
        <InfoContent>{normalizedDuplicateIndividual.firstName}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.Surname' /></InfoLabel>
        <InfoContent>{normalizedDuplicateIndividual.surname}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.FatherName' /></InfoLabel>
        <InfoContent>{normalizedDuplicateIndividual.fatherName}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.GrandfatherName' /></InfoLabel>
        <InfoContent>{normalizedDuplicateIndividual.grandfatherName}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.GreatGrandfatherName' /></InfoLabel>
        <InfoContent>{normalizedDuplicateIndividual.greatGrandfatherName}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.BirthDate' /></InfoLabel>
        <InfoContent>{formatDate(duplicateIndividual.birthDate)}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel><Resx name='Individuals.PersonalIds' /></InfoLabel>
        <InfoContent>
          <table style={{ width: '100%' }}>
            <tbody>
              {duplicateIndividual.personalIds.map(personalId =>
                <tr key={`individualComparison_personalId_${personalId.id}`}>
                  <td>
                    {personalId.type.name}
                  </td>
                  <td>
                    {personalId.number}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </InfoContent>
      </InfoRow>
    </Col>
  </React.Fragment>
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/dataCrossing/individual-comparison-detail.js